import { FC } from 'react';
import { ILSButtonTooltip, ILSUserConfirm } from '@common/components';
import { DriverTableButtons } from '@modules/catalog/constants/tables/mobile-application-buttons';
import { EMPTY_STRING } from '@common/constants';
import { HandleMobileApplicationAction } from '@modules/catalog/types/functions';
import { Driver } from '@common/types';

interface IProps {
  disabled: boolean;
  selectedDrivers: Array<Driver['ID']>;
  handleMobileApplicationAction: HandleMobileApplicationAction;
}

export const CatalogResendPasswordToDriverMobileApplicationButtonComponent: FC<IProps> = ({
  disabled,
  handleMobileApplicationAction,
  selectedDrivers
}) => {
  const handleClick = () => {
    ILSUserConfirm({
      text: 'Вы действительно хотите отправить выбранному водителю пароль для входа в мобильное приложение?',
      onConfirm: handleMobileApplicationAction,
      confirmParams: { operation: DriverTableButtons.ResendPassword, driverIDs: selectedDrivers },
      onConfirmText: `Отправить ${selectedDrivers.length ?? EMPTY_STRING}`,
      onCloseText: 'Нет'
    });
  };

  return (
    <ILSButtonTooltip
      children={'Повторная отправка пароля'}
      disabled={disabled}
      title={'Система отправит данному водителю смс с паролем для входа в мобильное приложение'}
      onClick={handleClick}
    />
  );
};
